/** Shared Journey workspace section links — AUTH-35 IA groups + FE-IA-V2-05 iaKey（routes unchanged）. */

const CORE = 'core';
const PLAN = 'plan';
const COLLAB = 'collab';
const MEMORY = 'memory';
const MONEY = 'money';
/** 顯示文案 key；`label` 保留繁中預設值供既有相容用途，畫面一律以 labelKey 翻譯。 */
const N = 'travel.journeyWorkspace.nav';

/**
 * Canonical grouping for Journey workspace navigation.
 * UX-03-A: product-language labels; routes/capabilities preserved.
 * FE-IA-V2-05: iaKey maps Overview／Planning／Stays／Transport／Cost／People。
 */
export function workspaceNavGroups(journeyId) {
  const id = String(journeyId);
  return [
    {
      id: CORE,
      labelKey: null,
      label: null,
      alwaysOpen: true,
      items: [
        { to: `/journeys/${id}`, labelKey: `${N}.item.overview`, label: '總覽', end: true, iaKey: 'overview', testId: 'journey-nav-overview' },
        { to: `/journeys/${id}/planning`, labelKey: `${N}.item.planning`, label: '規劃', end: true, iaKey: 'planning', testId: 'journey-nav-planning' },
        { to: `/journeys/${id}/today`, labelKey: `${N}.item.today`, label: '今日', end: true, iaKey: 'today', testId: 'nav-today' },
        { to: `/journeys/${id}/people`, labelKey: `${N}.item.people`, label: '旅伴', end: true, iaKey: 'people', testId: 'journey-nav-people' },
      ],
    },
    {
      id: PLAN,
      labelKey: `${N}.group.plan`,
      label: '行程安排',
      alwaysOpen: false,
      items: [
        { to: `/journeys/${id}/stays`, labelKey: `${N}.item.stays`, label: '住宿', end: true, iaKey: 'stays', testId: 'journey-nav-stays' },
        { to: `/journeys/${id}/transport`, labelKey: `${N}.item.transport`, label: '交通', end: true, iaKey: 'transport', testId: 'journey-nav-transport' },
        { to: `/journeys/${id}/checklist`, labelKey: `${N}.item.checklist`, label: '清單', end: true, iaKey: 'checklist', testId: 'journey-nav-checklist' },
      ],
    },
    {
      id: COLLAB,
      labelKey: `${N}.group.collab`,
      label: '協作',
      alwaysOpen: false,
      items: [
        { to: `/journeys/${id}/timeline`, labelKey: `${N}.item.timeline`, label: '動態', end: true, iaKey: 'timeline', testId: 'journey-nav-timeline' },
        { to: `/journeys/${id}/notices`, labelKey: `${N}.item.notices`, label: '通知', end: true, badge: 'notices', iaKey: 'notices', testId: 'journey-nav-notices' },
        { to: `/journeys/${id}/chat`, labelKey: `${N}.item.chat`, label: '旅程聊天室', end: true, iaKey: 'chat', testId: 'journey-nav-chat' },
        { to: `/journeys/${id}/decisions`, labelKey: `${N}.item.decisions`, label: '決定', end: true, iaKey: 'decisions', testId: 'journey-nav-decisions' },
        { to: `/journeys/${id}/situations`, labelKey: `${N}.item.situations`, label: '旅程狀況', end: true, iaKey: 'situations', testId: 'journey-nav-situations' },
      ],
    },
    {
      id: MEMORY,
      labelKey: `${N}.group.memory`,
      label: '紀錄',
      alwaysOpen: false,
      items: [
        { to: `/journeys/${id}/journal`, labelKey: `${N}.item.journal`, label: '日記', end: true, iaKey: 'journal', testId: 'journey-nav-journal' },
      ],
    },
    {
      id: MONEY,
      labelKey: `${N}.group.money`,
      label: '費用',
      alwaysOpen: false,
      iaKey: 'cost',
      items: [
        { to: `/journeys/${id}/budget`, labelKey: `${N}.item.budget`, label: '預算', end: true, iaKey: 'cost', testId: 'journey-nav-budget' },
        { to: `/journeys/${id}/expenses`, labelKey: `${N}.item.expenses`, label: '支出', end: true, iaKey: 'cost', testId: 'journey-nav-expenses' },
        { to: `/journeys/${id}/split`, labelKey: `${N}.item.split`, label: '分帳', end: true, iaKey: 'cost', testId: 'journey-nav-split' },
      ],
    },
  ];
}

/** Flat list in display order (Core → Plan+ → Collab → Memory → Money). */
export function workspaceLinks(journeyId) {
  return workspaceNavGroups(journeyId).flatMap((group) => group.items);
}

/** FE-IA-V2-05：IA canonical destinations must stay reachable（含 Cost 三頁）。 */
export function workspaceIaReachableLinks(journeyId) {
  const links = workspaceLinks(journeyId);
  const byKey = (iaKey) => links.filter((item) => item.iaKey === iaKey);
  return {
    overview: byKey('overview'),
    planning: byKey('planning'),
    stays: byKey('stays'),
    transport: byKey('transport'),
    cost: byKey('cost'),
    people: byKey('people'),
  };
}
